var map = {
	"./en.json": [
		"edd4"
	],
	"./ja.json": [
		"0423",
		"chunk-2d0a3c3b"
	],
	"./ko.json": [
		"dd11",
		"chunk-2d229396"
	],
	"./ms-MY.json": [
		"6579",
		"chunk-2d0cfad7"
	],
	"./th.json": [
		"8680",
		"chunk-2d0de76c"
	],
	"./zh-CN.json": [
		"423e0",
		"chunk-7474ca6a"
	],
	"./zh-TW.json": [
		"9ea5",
		"chunk-2d0f1136"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;